import React, { useEffect } from 'react';
import { Shield, Target, Users, CheckCircle, XCircle } from 'lucide-react';
import { CTABanner } from '../components/CTABanner';
export function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full" data-id="element-213">
      {/* Hero */}
      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden" data-id="element-214">
        <div className="absolute inset-0 bg-cover bg-center z-0" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1200")'
      }} data-id="element-215"></div>
        <div className="absolute inset-0 bg-navy/80 z-10" data-id="element-216"></div>
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-217">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-montserrat font-black text-white mb-6" data-id="element-218">
            About Softwash Pros
          </h1>
          <p className="text-xl text-cream max-w-3xl mx-auto" data-id="element-219">
            Dedicated to providing the safest, most effective exterior cleaning
            solutions.
          </p>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-16 md:py-24 bg-white" data-id="element-220">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-222">
            <div data-id="element-223">
              <h2 className="text-3xl font-montserrat font-bold text-navy mb-6" data-id="element-224">
                Our Story
              </h2>
              <p className="text-gray-600 text-lg mb-4" data-id="element-225">
                Founded locally, Softwash Pros was built on a simple premise:
                exterior cleaning shouldn't mean damaging your property. We saw
                too many homes damaged by high-pressure washing and knew there
                had to be a better way.
              </p>
              <p className="text-gray-600 text-lg mb-6" data-id="element-226">
                Today, we are the area's premier soft washing specialists. Our
                team of trained professionals uses state-of-the-art equipment
                and eco-friendly, biodegradable solutions to safely remove
                algae, mold, mildew, and dirt from your home's exterior.
              </p>
              <div className="flex items-center space-x-4 text-navy font-bold" data-id="element-227">
                <div className="flex items-center" data-id="element-228">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-2" data-id="element-229" />
                  Fully Licensed
                </div>
                <div className="flex items-center" data-id="element-230">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-2" data-id="element-231" />
                  Fully Insured
                </div>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-232">
              <img src="https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=1200" alt="Softwash Pros Team" className="w-full h-full object-cover" data-id="element-233" />
            </div>
          </div>
        </div>
      </section>

      {/* Mission/Values */}
      <section className="py-16 bg-gray-50" data-id="element-234">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-235">
          <div className="text-center mb-12" data-id="element-236">
            <h2 className="text-3xl font-montserrat font-bold text-navy mb-4" data-id="element-237">
              Our Core Values
            </h2>
            <div className="w-24 h-1 bg-light-blue mx-auto rounded-full" data-id="element-238"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-239">
            <div className="bg-white p-8 rounded-xl shadow-soft text-center border border-gray-100" data-id="element-240">
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-241">
                <Target className="w-8 h-8 text-navy" data-id="element-242" />
              </div>
              <h3 className="text-xl font-montserrat font-bold text-navy mb-3" data-id="element-243">
                Quality
              </h3>
              <p className="text-gray-600" data-id="element-244">
                We never cut corners. We use the best equipment and solutions to
                deliver exceptional results every time.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-soft text-center border border-gray-100" data-id="element-245">
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-246">
                <Shield className="w-8 h-8 text-navy" data-id="element-247" />
              </div>
              <h3 className="text-xl font-montserrat font-bold text-navy mb-3" data-id="element-248">
                Integrity
              </h3>
              <p className="text-gray-600" data-id="element-249">
                Honest pricing, transparent communication, and we stand behind
                our work with a satisfaction guarantee.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-soft text-center border border-gray-100" data-id="element-250">
              <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-251">
                <Users className="w-8 h-8 text-navy" data-id="element-252" />
              </div>
              <h3 className="text-xl font-montserrat font-bold text-navy mb-3" data-id="element-253">
                Customer First
              </h3>
              <p className="text-gray-600" data-id="element-254">
                Your property is treated with the utmost respect, as if it were
                our own home.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why We're Different */}
      <section className="py-16 md:py-24 bg-white" data-id="element-255">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-256">
          <div className="text-center mb-16" data-id="element-257">
            <h2 className="text-3xl font-montserrat font-bold text-navy mb-4" data-id="element-258">
              Soft Washing vs. Pressure Washing
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-259">
              Understanding the difference is crucial for protecting your
              property's exterior.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-260">
            {/* Soft Wash */}
            <div className="bg-navy rounded-2xl p-8 text-white shadow-xl relative overflow-hidden" data-id="element-261">
              <div className="absolute top-0 right-0 -mr-10 -mt-10 w-40 h-40 bg-light-blue opacity-20 rounded-full blur-2xl" data-id="element-262"></div>
              <h3 className="text-2xl font-montserrat font-bold mb-6 flex items-center" data-id="element-263">
                <CheckCircle className="w-8 h-8 text-light-blue mr-3" data-id="element-264" />
                Soft Washing (Our Method)
              </h3>
              <ul className="space-y-4" data-id="element-265">
                <li className="flex items-start" data-id="element-266">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-3 shrink-0 mt-0.5" data-id="element-267" />
                  <span data-id="element-268">Uses low pressure (similar to a garden hose)</span>
                </li>
                <li className="flex items-start" data-id="element-269">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-3 shrink-0 mt-0.5" data-id="element-270" />
                  <span data-id="element-271">
                    Relies on specialized, eco-friendly cleaning solutions
                  </span>
                </li>
                <li className="flex items-start" data-id="element-272">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-3 shrink-0 mt-0.5" data-id="element-273" />
                  <span data-id="element-274">Kills algae, mold, and bacteria at the root</span>
                </li>
                <li className="flex items-start" data-id="element-275">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-3 shrink-0 mt-0.5" data-id="element-276" />
                  <span data-id="element-277">Results last 4-6 times longer</span>
                </li>
                <li className="flex items-start" data-id="element-278">
                  <CheckCircle className="w-5 h-5 text-light-blue mr-3 shrink-0 mt-0.5" data-id="element-279" />
                  <span data-id="element-280">
                    100% safe for siding, roofs, and delicate surfaces
                  </span>
                </li>
              </ul>
            </div>

            {/* Pressure Wash */}
            <div className="bg-gray-50 rounded-2xl p-8 border border-gray-200 shadow-soft" data-id="element-281">
              <h3 className="text-2xl font-montserrat font-bold text-gray-800 mb-6 flex items-center" data-id="element-282">
                <XCircle className="w-8 h-8 text-red-500 mr-3" data-id="element-283" />
                Traditional Pressure Washing
              </h3>
              <ul className="space-y-4 text-gray-600" data-id="element-284">
                <li className="flex items-start" data-id="element-285">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-286" />
                  <span data-id="element-287">Uses destructive high pressure (up to 4000 PSI)</span>
                </li>
                <li className="flex items-start" data-id="element-288">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-289" />
                  <span data-id="element-290">Only blasts away the surface layer of dirt</span>
                </li>
                <li className="flex items-start" data-id="element-291">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-292" />
                  <span data-id="element-293">Leaves root spores behind to regrow quickly</span>
                </li>
                <li className="flex items-start" data-id="element-294">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-295" />
                  <span data-id="element-296">Can force water behind siding causing mold</span>
                </li>
                <li className="flex items-start" data-id="element-297">
                  <XCircle className="w-5 h-5 text-red-400 mr-3 shrink-0 mt-0.5" data-id="element-298" />
                  <span data-id="element-299">
                    High risk of stripping paint and damaging shingles
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <CTABanner data-id="element-300" />
    </div>;
}